import store from '../store/index.js';
import CryptoJS from 'crypto-js';

// 十六位十六进制数作为密钥
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF");
// 十六位十六进制数作为密钥偏移量
const iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412");
// 解密方法
function Decrypt(word) {
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
// 加密方法
function Encrypt(word) {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}
// 判断用户权限
export const hasOperate = (oName) => {
  let operates = store.getters.userOperates || [];
  for (let i = 0; i < operates.length; i++) {
    if (operates[i] && operates[i].operateCode && operates[i].operateCode == oName) {
      return true;
    }
  }
  return false;
}

export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return;
  let i = -1;
  let len = arr.length;
  while (++i < len) {
    let item = arr[i];
    fn(item, i, arr);
  }
};

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = routers => {
  let i = -1;
  let len = routers.length;
  let homeRoute = {};
  while (++i < len) {
    let item = routers[i];
    if (item.childs && item.childs.length) {
      let res = getHomeRoute(item.childs);
      if (res.name) return res;
    } else {
      if (item.name === 'home') homeRoute = item;
    }
  }
  return homeRoute;
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (list, path) => {
  let temp = [];
  let forFn = function(arr, name, result) {
    for (var i = 0; i < arr.length; i++) {
      let item = arr[i];
      let res = JSON.parse(JSON.stringify(result));
      res.push(item);
      if (item.path === name) {
        temp = [].concat(res);
        break
      } else {
        if (item.childs) {
          forFn(item.childs, name, res)
        }
      }
    }
  }
  forFn(list, path, []);
  return temp;
};


/**
 * 获取当前登陆的用户的权限集合数据
 * @param list {Array} 所有的路由集合数据
 * @param access {Array} 当前允许登陆的路由集合数据
 */
export const getLoginMenuList = (list, router, access) => {
  let res = [];
  forEach(list, item => {
    let obj = {
      icon: item.icon || '',
      CNname: item.name,
      name: item.name,
      code: item.id || '',
      path: item.path,
      operates: item.operates && item.operates.length > 0 ? item.operates : null,
    };
    for(let i = 0; i < router.length; i++) {
      if(router[i].path === item.path) {
        obj.name = router[i].name;
        break;
      }
    }
    if (hasChild(item) && showThisMenuEle(item, access)) {
      obj.childs = getLoginMenuList(item.childs, router, access);
    }
    if (showThisMenuEle(item, access)) res.push(obj);
  });

  return res;
}


/**
 * 功能描述： 判断当前登录的用户是否拥有节点的权限
 * @param item
 * @param access
 * @returns {boolean}
 */
const showThisMenuEle = (item, access) => {
  // let code = item.meta.code;
  // if(access.indexOf(code)!=-1){
  //   return true;
  // }else{
  //   return false;
  // }
  return true;
}

/**
 * 功能描述： 判断即将访问页面是否有权限
 * @param path
 * @returns {toPath}
 */
export const checkCanPath = (path, tree) => {
  let arr = Array.isArray(tree) ? tree : [tree];
  let result = null;
  while (arr.length) {
    let item = arr.pop();
    if (item && item.path === path) {
      result = item;
      break;
    } else if (item && item.childs && item.childs.length) {
      arr.push(...item.childs);
    }
  }
  return result;
}

export const hasChild = (item) => {
  return item.childs != undefined && item.childs.length !== 0;
};

// 精度计算
// 首先是加法 （这里以两个数据相加为例）

function add(arg1, arg2) {
  arg1 = Number(arg1 || 0).toString(), arg2 = Number(arg2 || 0).toString(); // 将传入的数据转化为字符串
  var arg1Arr = arg1.split("."), // 将小数的数据从小数点的位置拆开
    arg2Arr = arg2.split("."),
    d1 = arg1Arr.length == 2 ? arg1Arr[1] : "", // 获取第一个数的小数点的长度
    d2 = arg2Arr.length == 2 ? arg2Arr[1] : ""; // 获取第二个数的小数点的长度
  var maxLen = Math.max(d1.length, d2.length); // 获取小数点长度较大的值
  var m = Math.pow(10, maxLen); // 这里表示10的小数点长度次方 也就是说如果小数点长度为2 m的值就是100 如果小数点长度是3 m的值就是1000如果不懂请自行查找api
  var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen)); // 将小数转化为整数后相加在除掉两个数乘过的倍数然后去小数点较长的长度的小数位数
  var d = arguments[2]; // 第三个参数用户可以自行决定是否要传递 用来定义要保留的小数长度
  return typeof d === "number" ? Number((result).toFixed(d)) : result;
}

// 然后是减法 （减法其实就是一个数组加上另一个数字的负数所以和加法逻辑相同）
function sub(arg1, arg2) {
  return add(Number(arg1 || 0), -Number(arg2 || 0));
}

// 其次是乘法
function mul(arg1, arg2) {
  var r1 = Number(arg1 || 0).toString(), // 将传入的数据转化为字符串
    r2 = Number(arg2 || 0).toString(),
    m, resultVal, d = arguments[2];
  m = (r1.split(".")[1] ? r1.split(".")[1].length : 0) + (r2.split(".")[1] ? r2.split(".")[1].length :
    0); // 获取两个数字的小数位数的和
  // 乘积的算法就是去掉小数点做整数相乘然后除去10的所有小数位的次方
  resultVal = Number(r1.replace(".", "")) * Number(r2.replace(".", "")) / Math.pow(10, m);

  return typeof d !== "number" ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
}

// 最后是除法 (除法和乘法就是一个相反的过程，不做过多解释)
function div(arg1, arg2) {
  var r1 = Number(arg1 || 0).toString(),
    r2 = Number(arg2 || 0).toString(),
    m, resultVal, d = arguments[2];
  m = (r2.split(".")[1] ? r2.split(".")[1].length : 0) - (r1.split(".")[1] ? r1.split(".")[1].length : 0);
  resultVal = Number(r1.replace(".", "")) / Number(r2.replace(".", "")) * Math.pow(10, m);
  return typeof d !== "number" ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
}

// 数字转换成万和亿
function formatNum(number) {
  let num = 0
  if (!number) {
    num = 0;
  } else {
    if (number >= 100000000) {
      num = parseFloat(div(number, 100000000).toFixed(4)) + '亿';
    } else if (number >= 10000) {
      num = parseFloat(div(number, 10000).toFixed(3)) + '万';
    } else {
      num = parseFloat(number);
    }
  }
  return num;
}

function formatNumberWithCommas(value) {
  if(isNaN(value)) {
    return '0.00';
  } else {
    let number = `${Number(value)}`;
    let [integer, decimal] = number.split('.');
    const doSplit = (num) => {
      num = num.replace('-', '').replace('+', '').split('').reverse();
      let str = [];
      for(let i = 0; i < num.length; i++) {
        if(i !== 0 && i % 3 === 0) str.push(',');
        str.push(num[i]);
      }
      return str.reverse().join('');
    };
    integer = doSplit(integer);
    decimal = !decimal ? '.00' : decimal.length < 2 && decimal.length < 2 ? `.${decimal}0` : `.${decimal}`;
    return (value < 0 ? '-' : '') + integer + decimal;
  }
};

const payType = {
  '01': '工银e支付',
  '02': '微信支付',
  '03': '支付宝',
  '04': '预付卡',
  '05': '转账',
  '07': 'POS支付',
  '08': 'e支付有协议小额免密',
  '09': '微信线下支付',
  '10': '会员卡小额免密',
  '11': '支付宝线下支付',
  '12': '二维码被扫支付',
  '99': '其他'
}

const orderState = {
  '00': '初始',
  '01': '支付中', // 弹出收银台后选择支付方式
  '02': '支付成功',
  '03': '支付失败',
  '04': '可疑',
  '07': '记账成功',
  '08': '记账成功支付中',
  '09': '记账成功支付成功',
  '10': '记账成功支付失败',
  '11': '记账成功补帐中',
  '12': '记账成功补帐成功',
  '13': '记账成功补帐失败',
  '14': '记账成功已核销',
  '15': '生成订单二维码失败',
}

const transType = {
  '01': '入金分账',
  '02': '交易划转',
  '03': '提现',
  '04': '提现手续费',
  '05': '提现退汇',
  '06': '渠道来账',
  '07': '支付交易',
  '08': '退款交易',
  '09': '平台商户预付交易',
  '11': '平台扣罚',
  '12': '平台补贴',
  '13': '实时预清分',
  '10': '其他',
  'JJ01': '平台自营资金划转',
  'JJ02': '用户提现',
  'JJ03': '平台提现',
  'JJ04': '用户退汇',
  'JJ05': '平台退汇',
  'JJ06': '清分入金',
  'JJ07': '来帐登记',
  'JJ08': '提现手续费',
  'JJ09': '不明来账调增登记簿',
  'JJ10': '居间手续费结算',
  'JJ11': '待结算手续费清算回退',
  'JJ12': '28位打款账号调增登记簿',
  'JJ13': '28位打款账号调减登记簿',
  'JJ15': '不明来账调减登记簿',
  'JJ16': '日终清分往自由资金转账',
  'JJ17': '不明来账重新匹配',
  'JJ18': '28位部分退款调减登记簿',
  'JJ19': '28位部分退款失败/退汇调增登记簿',
  'JJ20': '普通绑卡入金部分退款调减登记簿',
  'JJ21': '普通绑卡入金部分退款失败/退汇调增登记簿',
  'JJJX': '结息批量',
  'JJZZ': '登记簿资金划转',
  'JJRJ': '转账入金',
  'JJXF': '支付',
  'JJTK': '退款',
  'JJHC': '平台商户补贴',
  'JJHR': '平台商户扣罚',
  'JJYF': '预付交易',
  'YQZF': '预清分支付',
  'YQCX': '预清分撤销',
  'YQTK': '预清分退款',
  'YQHX': '预清分核销',
}

let utils = {
  title,
  add,
  sub,
  mul,
  div,
  hasOperate,
  payType,
  orderState,
  Decrypt,
  Encrypt,
  formatNum,
  formatNumberWithCommas,
  checkCanPath,
  transType
};

function title(title) {
  title = title ? title : '';
  window.document.title = title;
};

export default utils;



// WEBPACK FOOTER //
// ./src/libs/utils.js